import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=5944fe48&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944fe48",
  null
  
)

export default component.exports